/**
 * TanStack Query hooks for `self-signup-manual-approval-for-advertiser-accounts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	selfSignupManualApprovalForAdvertiserAccountsQueryKeys,
	type CreateSelfSignupManualApprovalForAdvertiserAccountsBody,
	type ListSelfSignupManualApprovalForAdvertiserAccountsResponse,
	type SelfSignupManualApprovalForAdvertiserAccountsRow,
} from "./api";

export function useSelfSignupManualApprovalForAdvertiserAccountsList(): UseQueryResult<ListSelfSignupManualApprovalForAdvertiserAccountsResponse, Error> {
	return useQuery({
		queryKey: selfSignupManualApprovalForAdvertiserAccountsQueryKeys.list(),
		queryFn: list,
	});
}

export function useSelfSignupManualApprovalForAdvertiserAccountsCreate(): UseMutationResult<SelfSignupManualApprovalForAdvertiserAccountsRow, Error, CreateSelfSignupManualApprovalForAdvertiserAccountsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfSignupManualApprovalForAdvertiserAccountsQueryKeys.all });
		},
	});
}

export function useSelfSignupManualApprovalForAdvertiserAccountsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfSignupManualApprovalForAdvertiserAccountsQueryKeys.all });
		},
	});
}
